import React from 'react';
import { Link } from 'react-router-dom';
import tubulins from '../images/challenge2016.png';
import Leaderboard from './Leaderboard';

class Challenge extends React.Component {
    constructor(props) {
        super(props);
    }
    render() {
        return (
        <div>
            <div style={{"display":"flex"}}>
                <span>
                    <h1>3D SMLM Software Challenge</h1>
                    <p className="abstract">
                    The 3D SMLM challenge is an ongoing competition to assess SMLM software on both simulated and real 
                    reference datasets using objective assessment metrics. 
                    </p>
                    <p className="abstract">
                    The 3D challenge submission process is currently on hold and may resume shortly. {/*<Link to={"/Challenge/SubmitResults"}>new submissions </Link> from both 2D and 3D SMLM software.*/} 
                    </p>
                    <p className="abstract">
                    The challenge results for the <Link to={"/Challenge/ChallengeSimulatedData"}> simulated datasets </Link> are presented below (see <Link to={"/Challenge/Methods"}>Methods</Link> section for details).
                    </p>
                    <p className="abstract">
                    The challenge results for the <Link to={"/Challenge/ChallengeRealData"} >experimental datasets</Link> are available <Link to={"/Challenge/ChallengeRealDataResults"}>here</Link>.
                    </p>
                </span>
                <span style={{padding:"10px"}}>
                    <img src={tubulins}  alt="banner"/>
                </span>
            </div>
            <br></br>
            <Leaderboard />
        </div>
      );
    }
}

export default Challenge;